import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchDialogComponent } from '@Work/Accounts/proprietary/controls/search-dialog.component';
import { DataService } from '@Core/services/proprietary/data.service';
import { AppService } from '../../../../../core/services/proprietary/app.service';

@Component({
    standalone: false,
    selector: 'workgroup-search-dialog',
    templateUrl: './workgroup-search-dialog.component.html',
    providers: [DataService]
})
export class WorkgroupSearchDialogComponent extends SearchDialogComponent {
    constructor(private injector: Injector, private activeModal: NgbActiveModal, public app: AppService) {
        super(injector);
    }

    initialize(): boolean {
        this.parentActiveModal = this.activeModal;
        this.objectType = 'Workgroup';
        this.model.title = 'Select Workgroup';

        this.model.criteria.Max = this.model.currentOptions.maxRows;
        this.model.criteria.Disabled_Ind = 'N';

        if (!this.model.criteria.View) {
            this.model.criteria.View = 'Full';
        }

        return true;
    }
}
